// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --mainFocusColor: #35c6c9;
}

.react-tel-input .selected-flag:focus .arrow {
  border-top: 5px solid var(--mainFocusColor);
}

.react-tel-input .special-label {
  top: -7px;
  left: 10px;
  padding: 0 5px;
  font-size: 12px !important;
}
.react-tel-input :disabled {
  cursor: default;
}

.react-tel-input .form-control:hover:disabled,
.react-tel-input .form-control {
  border-color: rgba(0, 0, 0, 0.38) ;
}

.react-tel-input .special-label:has(+ .form-control:disabled),
.form-control:disabled {
  color: rgba(0, 0, 0, 0.38);
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/telephoneInput.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":[":root {\n  --mainFocusColor: #35c6c9;\n}\n\n.react-tel-input .selected-flag:focus .arrow {\n  border-top: 5px solid var(--mainFocusColor);\n}\n\n.react-tel-input .special-label {\n  top: -7px;\n  left: 10px;\n  padding: 0 5px;\n  font-size: 12px !important;\n}\n.react-tel-input :disabled {\n  cursor: default;\n}\n\n.react-tel-input .form-control:hover:disabled,\n.react-tel-input .form-control {\n  border-color: rgba(0, 0, 0, 0.38) ;\n}\n\n.react-tel-input .special-label:has(+ .form-control:disabled),\n.form-control:disabled {\n  color: rgba(0, 0, 0, 0.38);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
